/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/230-sad': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13zM4 5a1 1 0 112 0 1 1 0 01-2 0zm6 0a1 1 0 112 0 1 1 0 01-2 0zm-5.002 7.199l-1.286-.772C4.586 9.973 6.179 9 8 9s3.413.973 4.288 2.427l-1.286.772C10.39 11.181 9.275 10.5 8 10.5s-2.389.681-3.002 1.699z"/>'
  }
})
